// Facebook initialization

window.fbAsyncInit = function() {

  Facebook_Bug = window.location.hash;
  
  FB.init({
    appId      : '783700495040097',
    xfbml      : true,
    version    : 'v3.0',
    status : true
  });
  
  window.location.hash = Facebook_Bug;

  FB.Event.subscribe('auth.statusChange', function(Status_Response) {
  	console.log(Status_Response);
	  if (Status_Response.status == "connected") {
	  	Jelly.Connections.Facebook_Get_Scope();
	  }
	});
};

(function(d, s, id){
   var js, fjs = d.getElementsByTagName(s)[0];
   if (d.getElementById(id)) {return;}
   js = d.createElement(s); js.id = id;
   js.src = "//connect.facebook.net/en_US/sdk.js";
   fjs.parentNode.insertBefore(js, fjs);
 }(document, 'script', 'facebook-jssdk'));


Jelly.Connections.Facebook_Scope = null;

Jelly.Connections.Facebook_Get_Scope = function (Parameters) {
	
	// Get available permissions
	Jelly.Connections.Facebook_Scope = [];
	FB.api("/me/permissions", {status: "granted"}, function (API_Response) { 
		$.each(API_Response.data, function(Key, Val){
			if (Val.status == "granted")
				Jelly.Connections.Facebook_Scope.push(Val.permission);
		});	

		// Call callback
		if (Parameters && Parameters.Then)
			Parameters.Then();
	});
}

Jelly.Connections.Facebook_Logout = function () {
	if (Jelly.Connections.Facebook_Scope !== null) { 
		Jelly.Connections.Facebook_Scope = null;
		FB.logout();
	}
}
  
Jelly.Connections.Facebook_Login = function(Parameters) {
	var Continue_Facebook_Login = function (Parameters) { 
		FB.api('/me', {fields: 'id, link, name, email, first_name, last_name'}, function(API_Response) {
				if (!API_Response["error"]) {
					console.log(API_Response);
					console.log(Parameters);

					// Localize account information
					var ID = API_Response["id"];
					var URL = API_Response["link"];
					var Email = API_Response["email"];
					var Name = API_Response["name"];
					var First_Name = API_Response["first_name"];
					var Last_Name = API_Response["last_name"];
					var Path_To_Profile_Photo = "https://graph.facebook.com/" + ID + "/picture?type=large";
					var Namespace = Parameters["Namespace"];

					// Save input values
					Jelly.Actions.Set_Input_Value({
							Namespace: Namespace,
							Alias: "Account_Platform",
							Value: "Facebook"
					});
					Jelly.Actions.Set_Input_Value({
						Namespace: Namespace,
						Alias: "Account_ID",
						Value: ID
					});
					Jelly.Actions.Set_Input_Value({
						Namespace: Namespace,
						Alias: "Account_URL",
						Value: URL
					});
					Jelly.Actions.Set_Input_Value({
						Namespace: Namespace,
						Alias: "Email_Address",
						Value: Email
					});
					Jelly.Actions.Set_Input_Value({
						Namespace: Namespace,
						Alias: "Person_Name",
						Value: Name
					});
					Jelly.Actions.Set_Input_Value({
						Namespace: Namespace,
						Alias: "First_Name",
						Value: First_Name
					});
					Jelly.Actions.Set_Input_Value({
						Namespace: Namespace,
						Alias: "Last_Name",
						Value: Last_Name
					});	
					Jelly.Actions.Set_Input_Value({
						Namespace: Namespace,
						Alias: "Picture_URL",
						Value: Path_To_Profile_Photo
					});
					
					// Execute action.
					Jelly.Handlers.Call_Handler_For_Target({
						Event: 'Execute', 
						Target: document.getElementById(Namespace)
					});
				}

				// Handle error
				else {
					
					if (Parameters["Error_Namespace"])
						var Error_Namespace = Parameters["Error_Namespace"];
					else
						var Error_Namespace = Parameters["Namespace"];

					Jelly.Actions.Show_Result({
						Namespace: Error_Namespace,
						Content: "Sorry! We were unable to log you in through Facebook."
					});
				}
		});
	}

	var Remaining_Required_Permissions = Jelly.Connections.Facebook_Login_Permissions_Needed();

	// If our list is blank, we have what we need
	if (!Remaining_Required_Permissions.length) {
		Continue_Facebook_Login(Parameters);
	}

	// Otherwise get the permissions
	else {

		if (Parameters.Direct) {
			// console.log("Launching Login");
			FB.login( function(Login_Response) {
					// console.log(Login_Response);
					// Handle errors
					Jelly.Connections.Facebook_Get_Scope({
						Then: function () {
							// From now on, it'll ask first 	
							delete Parameters.Direct;
							Jelly.Connections.Facebook_Login(Parameters);
						}
					});
				}, {
					scope: Remaining_Required_Permissions.join(", "), auth_type: 'rerequest'
				}
			);
		}

		else { 
			// Show disclaimer
			var Disclaimer_Parameters = {
				Calling_Namespace: Parameters.Namespace
			};
			if (Parameters.Error_Namespace)
				Disclaimer_Parameters.Error_Namespace = Parameters.Error_Namespace

			Jelly.Interface.Create_Window({
					Alias: "Facebook_Login_Disclaimer"			
				,	URL: "/Disclaimer/Facebook_Login_Permissions" + ":" + $.param(Disclaimer_Parameters).replace(/&/g, ",")
			});
		}
	}
};

Jelly.Connections.Facebook_Login_Permissions_Needed = function() { 

	// Needed permissions
	var Remaining_Required_Permissions = ["public_profile", "email"];
	
	// Check auto-populated array to see if we still need more permissions
	$.each(Jelly.Connections.Facebook_Scope, function(Key, Val){
		if (Remaining_Required_Permissions.indexOf(Val) > -1)
			Remaining_Required_Permissions.splice(Remaining_Required_Permissions.indexOf(Val), 1);
	});

	return Remaining_Required_Permissions;
}

Jelly.Connections.Facebook_Event_Permissions_Needed = function() { 
	// Needed permissions
	var Remaining_Required_Permissions = ["user_events", "pages_show_list", "pages_read_engagement"];
	
	// Check auto-populated array to see if we still need more permissions
	$.each(Jelly.Connections.Facebook_Scope, function(Key, Val){
		if (Remaining_Required_Permissions.indexOf(Val) > -1)
			Remaining_Required_Permissions.splice(Remaining_Required_Permissions.indexOf(Val), 1);
	});

	return Remaining_Required_Permissions;
}

Jelly.Connections.Facebook_Events = function(Parameters) { 
	var Continue_Facebook_Events = function (){
		
		// Init sync variables
		var Upcoming_Events = [];
		var Now = Date.now();

		// Handle events
		var Handle_Personal_Events = function (API_Response) {

			var Keep_Goin = true;

			var Page = (API_Response.events ? API_Response.events : API_Response);

			for (var Event_Index in Page.data) {
	    	if (Page.data.hasOwnProperty(Event_Index)) {
		    	var Current_Event = Page.data[Event_Index];
		    	var Current_Start_Time = moment(Current_Event.start_time, moment.ISO_8601).valueOf();

		    	// TODO - this is allegedly deprecated but also the only thing that works, even in 3.2
		    	var is_viewer_admin = false;
		    	var me = API_Response.id;
		    	for (var Admin_Index in Current_Event.admins.data) {if (Current_Event.admins.data.hasOwnProperty(Event_Index)) {
		    		if (Current_Event.admins.data[Admin_Index].id == me) {
		    			is_viewer_admin = true;
		    		}
		    	}}

		    	// If I'm an admin and this event is in the future
		    	if (is_viewer_admin && Current_Start_Time > Now)
		    		Upcoming_Events.push(Jelly.Connections.Parse_Facebook_Event(Current_Event));
		    	else { 
		    		// Stop paging if we've passed now
		    		if (Current_Start_Time <= Now)
		    			Keep_Goin = false;
		    	}
	    	}
	    }

	    // Get next events
	    if (Keep_Goin && Page.paging && Page.paging.next) { 
	    	FB.api(Page.paging.next, Handle_Personal_Events);
	    }

	    // Handle facebook page, only if permissions granted ...
	    else if (Remaining_Required_Permissions.indexOf("pages_show_list") == -1) {

	    	// Handle facebook pages 
	    	var Handle_Facebook_Page_Events = function (Accounts, Account_Index, API_Response) { 
	    		
	    		// Get account
	    		var Account = Accounts[Account_Index]

	    		// Setup fallback variables for facebook pages with no initial data set
	    		var Page = {data:[]};
	    		var Keep_Goin = false;

	    		// If this is the first time on the account, get provided data set
	    		if (typeof API_Response === 'undefined') {
	    			if (typeof Account.events === 'object') {
	    				Page = Account.events;
	    				Keep_Goin = true;
	    			}
	    		}

	    		// Subsequent times, get the data set from the passed in response
	    		else { 
	    			Page = API_Response;
	    			Keep_Goin = true;
	    		}

	    		// Loop through current data page of events
		    	for (var Event_Index in Page.data) {
						if (Page.data.hasOwnProperty(Event_Index)) {
			    		var Current_Event = Page.data[Event_Index];
			    		Current_Event.account = Account.name;
				    	var Current_Start_Time = moment(Current_Event.start_time, moment.ISO_8601).valueOf();;
				    	// If I'm an admin and this event is in the future
				    	if (Current_Start_Time > Now)
				    		Upcoming_Events.push(Jelly.Connections.Parse_Facebook_Event(Current_Event));
				    	else { 
				    		if (Current_Start_Time <= Now)
  								Keep_Goin = false;
				    	}
			    	}
			    }

			    // Continue facebook page events
			   	if (Keep_Goin && Page.paging && Page.paging.next) { 
			   		FB.api(Page.paging.next, function(API_Response) {
			   			Handle_Facebook_Page_Events(Accounts, Account_Index, API_Response);
			   		});
			   	}

			  	// After this facebook page has no more accounts
			   	else { 

			   		// Move to the next facebook page
			   		if (Account_Index < (Accounts.length - 1)) {
							Handle_Facebook_Page_Events(Accounts, Account_Index + 1);
			   		}

			   		// When there are no facebook pages left, sort and display the list
			   		else { 
		   				// Sort by start time
							Upcoming_Events.sort(function (a, b) {
							  return a.sort_time - b.sort_time;
							});			   		

							// Display in list
							$("#" + Parameters.Namespace + "_Event_List li.Loading").remove();
					    $("#" + Parameters.Namespace + "_Event_List_Wrapper .Controls").show();
					    for (var Event_Index in Upcoming_Events) {
					    	if (Upcoming_Events.hasOwnProperty(Event_Index)) {
						    	Jelly.Connections.Add_Facebook_Event_To_List({
						    		Input_Namespace: Parameters.Input_Namespace,
						    		Namespace: Parameters.Namespace,
						    		Event: Upcoming_Events[Event_Index], 
						    		May_Have_Already_Added_Events: Parameters.May_Have_Already_Added_Events
						    	});
					    	}
					    }
			   		}
			   	}
	    	}

	    	// Initiate facebook pages
				FB.api( "/me", "GET", {
						fields:"accounts.limit(250){events.limit(25){name,start_time,cover},name}"
					}, 
					function (API_Response) { 
						// Initiate page events
						Handle_Facebook_Page_Events(API_Response.accounts.data, 0);
					}
				);
	    }

	    /* TODO : Copy from above */
			else { 
				// Sort by start time
				Upcoming_Events.sort(function (a, b) {
				  return a.sort_time - b.sort_time;
				});			   		

				// Display in list
				$("#" + Parameters.Namespace + "_Event_List li.Loading").remove();
		    $("#" + Parameters.Namespace + "_Event_List_Wrapper .Controls").show();
		    for (var Event_Index in Upcoming_Events) {
		    	if (Upcoming_Events.hasOwnProperty(Event_Index)) {
			    	Jelly.Connections.Add_Facebook_Event_To_List({
			    		Input_Namespace: Parameters.Input_Namespace,
			    		Namespace: Parameters.Namespace,
			    		Event: Upcoming_Events[Event_Index], 
			    		May_Have_Already_Added_Events: Parameters.May_Have_Already_Added_Events
			    	});
		    	}
		    }
			}
		}

		// Initiate events
  	FB.api( "/me", "GET", {
				// fields:"events.limit(25){is_viewer_admin,name,start_time,cover}"
				fields:"events.limit(25){admins,name,start_time,cover}"
			}, 
			Handle_Personal_Events
		);
	}

	var Remaining_Required_Permissions = Jelly.Connections.Facebook_Event_Permissions_Needed();

	var Optional_Permissions = ["pages_show_list", "pages_read_engagement"];

	// If our list is blank, we have what we need, or what's missing is optional permissions, continue
	if (!Remaining_Required_Permissions.length || (!Parameters.Direct && Remaining_Required_Permissions.sort().join(',') === Optional_Permissions.sort().join(','))) {
		Continue_Facebook_Events();
	}

	// Otherwise get the permissions
	else {

		// TODO - What? 
		setTimeout( function(){
				$("#" + Parameters.Namespace + "_Event_List_Warning").show();
			},
			2500
		);
	
		// Init login directly
		if (Parameters.Direct) {
			FB.login( function(Login_Response) {
					// console.log(Login_Response);
					// Handle errors
					Jelly.Connections.Facebook_Get_Scope({
						Then: function () {
							// From now on, it'll ask first
							delete Parameters.Direct;
							Jelly.Connections.Facebook_Events(Parameters);
						}
					});
				}, {
					scope: Remaining_Required_Permissions.join(", "), auth_type: 'rerequest'
				}
			);
		}

		// Ask for permission first 
		else { 
			var Disclaimer_Parameters = {
					Calling_Namespace: Parameters.Namespace
				, Input_Namespace: Parameters.Input_Namespace
				, Organizing_Movement_Type: "Movement"
				, Organizing_Movement: Parameters.Organizing_Movement 
			};
			Jelly.Interface.Create_Window({
					Alias: "Facebook_Events_Disclaimer"			
				,	URL: "/Disclaimer/Facebook_Events_Permissions" + ":" + $.param(Disclaimer_Parameters).replace(/&/g, ",")
			});
		}

		// console.log("Launching Login");
	}
}

Jelly.Connections.Parse_Facebook_Event = function(Facebook_Event) {
	Event_Relevant_Data = {
		id: Facebook_Event.id,
		name: Facebook_Event.name, 
		start_time: Facebook_Event.start_time,
		sort_time: moment(Facebook_Event.start_time).format("YYYYMMDDHHmm")
	};

	if (Facebook_Event.account)
		Event_Relevant_Data.account = Facebook_Event.account;

	// console.log(Facebook_Event.cover);
	// console.log(typeof Facebook_Event);
	if (typeof Facebook_Event.cover == "object")
		Event_Relevant_Data.cover = Facebook_Event.cover.source;
	return Event_Relevant_Data;
};

Jelly.Connections.Select_Facebook_Event = function(Parameters) {
	FB.api( "/" + Parameters.Event_ID, "GET", {fields: "name, start_time, cover, place, description"}, function(API_Response) {

		var Namespace = Parameters.Namespace;

		// Name 
		Jelly.Actions.Set_Input_Value({ Namespace: Namespace,
			Alias: "Event_Name",
			Value: API_Response.name
		});

		// Location
		var Address = "";
		if (API_Response.place && API_Response.place.location) {
			Address += API_Response.place.name + ", " + 
				API_Response.place.location.street + ", " + 
				API_Response.place.location.city + ", " + 
				API_Response.place.location.state + ", " + 
				API_Response.place.location.zip + ", " + 
				API_Response.place.location.country
			;

			Jelly.Actions.Set_Input_Value({ Namespace: Namespace,
				Alias: "Location_Address",
				Value: Address
			});
		}

		// Cover
		if (API_Response.cover && API_Response.cover.source) {
			Jelly.Actions.Set_Input_Value({ Namespace: Namespace,
				Alias: "Cover",
				Value: API_Response.cover.source
			});
		}

		// Start Time
		var Start_Time = moment(API_Response.start_time, moment.ISO_8601).valueOf();
		if (API_Response.start_time) {
			Jelly.Actions.Set_Input_Value({Namespace: Namespace,
				Alias: "New_Tier_1_Start_Time",
				Value: API_Response.start_time
			});
		}

		// Description
		Jelly.Actions.Set_Input_Value({Namespace: Namespace,
			Alias: "Description",
			Value: API_Response.description
		});

		// Facebook ID
		Jelly.Actions.Set_Input_Value({Namespace: Namespace,
			Alias: "Facebook_ID",
			Value: Parameters.Event_ID
		});

		Jelly.Interface.Close_Top_Window();
	});
};

Jelly.Connections.Add_Facebook_Event_To_List = function(Parameters) {
	Start_Time = moment(Parameters.Event.start_time, moment.ISO_8601).valueOf();
	Now = Date.now();
	$Event_List = $("#" + Parameters.Namespace + "_Event_List");
	$("<li class=\"Event_List_Item" + ((Parameters.May_Have_Already_Added_Events.indexOf(Parameters.Event.id) > -1) ? " May_Have_Already_Added" : "") + "\" style=\"cursor:pointer;\" onclick=\"Jelly.Connections.Select_Facebook_Event({Namespace: '" + Parameters.Input_Namespace + "', Event_ID: '" + Parameters.Event.id + "'})\">" + 
		"	<div class=\"Cover\">" + 
		"		<div class=\"Image\" style=\"background-image: url(" + Parameters.Event.cover + ");\"></div>" +
		"			<div class=\"Basics\">" + 
			( 
				Parameters.Event.account ? 
		"				<h2 class=\"Page_Title\">" + Parameters.Event.account + "</h2>" :
		"" 
			) + 
		"				<h2 class=\"Title\">" + Parameters.Event.name + "</h2>" + 
		"			</div>" + 
		" 	</div>" +
		" <div class=\"Metadata\">" + 
		"	 <div class=\"Date six_columns ignore_break_point\">" + 
					moment(Start_Time).format("dddd") + ", " + 
					"<br class=\"Mobile_Only\"/> " +  (
						moment(Now).format("GGGG") == moment(Start_Time).format("GGGG") ? 
							moment(Start_Time).format("MMMM D") : 
							moment(Start_Time).format("MMMM D, GGGG")
						) + 
		"		</div>" + 
		" 	<span class=\"Share_Action offset_by_three_columns three_columns ignore_break_point\">" + 
		"			<label></label>" + 
		" 		<i class=\"fab fa-facebook-square\"></i>" + 
		" 	</span>" + 
		" </div>" + 
		" </li>"
		).appendTo($Event_List);
};